import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const SeniorSecondarySection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */

    const [form, setForm] = useState({
        heading: "",
        introduction_text: "",
    });

    /* IMAGES */
    const [image, setImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    /* ---------------- IMAGE STATES (CSR STYLE) ---------------- */
    const handleFileChange = (e) => {
        //setImage(e.target.files[0]);
        const file = e.target.files[0];
        setImage(file);

        if (file) {
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    /* ------------- Block State ------------------*/

    const [blocks, setBlocks] = useState([
        {
            block_type: "card_grid_1",
            heading: "",
            intro: "",
            items: [{ heading: "", content: "" }]
        },
        {
            block_type: "card_grid_2",
            heading: "",
            intro: "",
            items: [""]
        },
        {
            block_type: "card_grid_3",
            heading: "",
            intro: "",
            items: [{ heading: "", content: "" }]
        }
    ]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchContent();
    }, [school_slug]);

    const fetchContent = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/academic_page/get_senior_secondary/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const { section, blocks } = res.data.data;

                /* ---------- SECTION ---------- */
                if (section) {
                    setForm({
                        heading: section.heading || "",
                        introduction_text: section.introduction_text || ""
                    });

                    if (section.section_image) {
                        setPreviewImage(
                            `${baseAPIUrl}assets/images/academics/${section.section_image}?t=${Date.now()}`
                        );
                    }
                }

                /* ------------ BLOCKS --------------- */
                if (res.data.data.blocks && res.data.data.blocks.length) {
                    const fetchedBlocks = res.data.data.blocks;
                    //console.log(fetchedBlocks);
                    setBlocks(prevBlocks =>
                        prevBlocks.map(block => {
                            const saved = fetchedBlocks.find(
                                b => b.block_type === block.block_type
                            );

                            if (!saved) return block;
                            let content = saved.content;
                            // ✅ parse ONLY if string
                            if (typeof content === "string") {
                                try {
                                    content = JSON.parse(content);
                                } catch (e) {
                                    console.error("Invalid JSON in content:", saved.content);
                                    content = {};
                                }
                            }
                            // CARD GRID

                            if (block.block_type === "card_grid_1") {
                                return {
                                    block_type: "card_grid_1",
                                    heading: saved.heading || "",
                                    intro: saved.introduction || "",
                                    items: content.items || [{ heading: "", content: "" }]
                                };
                            }

                            if (block.block_type === "card_grid_2") {
                                return {
                                    block_type: "card_grid_2",
                                    heading: saved.heading || "",
                                    intro: saved.introduction || "",
                                    items: content.items || [""]
                                };
                            }

                            if (block.block_type === "card_grid_3") {
                                return {
                                    block_type: "card_grid_3",
                                    heading: saved.heading || "",
                                    intro: saved.introduction || "",
                                    items: content.items || [{ heading: "", content: "" }]
                                };
                            }
                            return block;
                        })
                    );
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


    /* HANDLERS */

    const updateComplexItem = (blockIndex, itemIndex, field, value) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[blockIndex].items[itemIndex][field] = value;
            return updated;
        });
    };

    const addComplexItem = (blockIndex) => {
        setBlocks(prev => {
            const updated = [...prev];
            if (updated[blockIndex].items.length >= 4) return prev;
            updated[blockIndex].items.push({ heading: "", content: "" });
            return updated;
        });
    };

    const removeComplexItem = (blockIndex, itemIndex) => {
        setBlocks(prev => {
            const updated = [...prev];
            if (updated[blockIndex].items.length <= 1) return prev;
            updated[blockIndex].items.splice(itemIndex, 1);
            return updated;
        });
    };


    const updateSimple = (blockIndex, key, value) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[blockIndex] = { ...updated[blockIndex], [key]: value };
            return updated;
        });
    };

    const updateSimpleItem = (blockIndex, itemIndex, value) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[blockIndex].items[itemIndex] = value;
            return updated;
        });
    };

    const addSimpleItem = (blockIndex) => {
        setBlocks(prev => {
            const updated = [...prev];
            if (updated[blockIndex].items.length >= 4) return prev;
            updated[blockIndex].items.push("");
            return updated;
        });
    };

    const removeSimpleItem = (blockIndex, itemIndex) => {
        setBlocks(prev => {
            const updated = [...prev];
            if (updated[blockIndex].items.length <= 1) return prev;
            updated[blockIndex].items.splice(itemIndex, 1);
            return updated;
        });
    };



    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };



    /* ---------------- Submit ---------------- */
    const sanitizeBlocks = (blocks) => {
        return blocks.map(block => {
            if (block.block_type === "card_grid_1") {
                return {
                    block_type: "card_grid_1",
                    heading: block.heading || "",
                    intro: block.intro || "",
                    content: JSON.stringify({
                        items: block.items.map(obj => ({
                            heading: obj.heading || "",
                            content: obj.content || ""
                        }))
                    })
                };
            }

            if (block.block_type === "card_grid_2") {
                return {
                    block_type: "card_grid_2",
                    heading: block.heading || "",
                    intro: block.intro || "",
                    content: JSON.stringify({
                        items: block.items
                    })
                };
            }

            if (block.block_type === "card_grid_3") {
                return {
                    block_type: "card_grid_3",
                    heading: block.heading || "",
                    intro: block.intro || "",
                    content: JSON.stringify({
                        items: block.items.map(obj => ({
                            heading: obj.heading || "",
                            content: obj.content || ""
                        }))
                    })
                };
            }

            // ✅ always return block
            return block;
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);
            const cleanBlocks = sanitizeBlocks(blocks);
            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify(form));
            formData.append("blocks", JSON.stringify(cleanBlocks));
            if (image) {
                formData.append("section_image", image);
            }
            const res = await axios.post(
                `${baseAPIUrl}admin/academic_page/add_edit_senior_secondary`,
                formData,
                { withCredentials: true }
            );
            await fetchContent();
            setMessage(res.data.message);
            scrollToTop();
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;
    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Senior secondary section</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Academic page</li>
                                <li class="breadcrumb-item active">Senior secondary section</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <h4>Edit Senior secondary section</h4>
                                </div>
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div class="card-body">
                                        {message && (
                                            <p className="text-center text-danger">{message}</p>
                                        )}
                                        {/* Heading */}
                                        <input type="hidden" name="school_slug" value={school_slug}></input>
                                        <div className="form-group">
                                            <label>Heading of section</label>
                                            <input
                                                type="text"
                                                name="heading"
                                                className="form-control"
                                                placeholder="Heading of section"
                                                value={form.heading}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Introduction text */}
                                        <div className="form-group">
                                            <label>Introduction text</label>
                                            <textarea
                                                name="introduction_text"
                                                rows="5"
                                                className="form-control"
                                                placeholder="Introduction text"
                                                value={form.introduction_text}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Blocks content */}
                                        <div className="form-group">
                                            {blocks.map((block, index) => (
                                                <div key={`${block.block_type}-${index}-${block.heading}-${block.intro_1}`} className="border p-3 mb-3">

                                                    <strong>{block.block_type.toUpperCase()}</strong>

                                                    {(block.block_type === "card_grid_1") && (
                                                        <>
                                                            <input
                                                                className="form-control mb-2"
                                                                placeholder="Section heading"
                                                                value={block.heading}
                                                                onChange={e => updateSimple(index, "heading", e.target.value)}
                                                            />

                                                            <textarea
                                                                className="form-control mb-2"
                                                                placeholder="Intro text"
                                                                value={block.intro}
                                                                onChange={e => updateSimple(index, "intro", e.target.value)}
                                                            />

                                                            {block.items.map((obj, i) => (
                                                                <div key={i} className="border p-2 mb-2">
                                                                    <input
                                                                        className="form-control mb-1"
                                                                        value={obj.heading}
                                                                        placeholder={`Heading ${i + 1}`}
                                                                        onChange={e =>
                                                                            updateComplexItem(index, i, "heading", e.target.value)
                                                                        }
                                                                    />
                                                                    <textarea
                                                                        className="form-control"
                                                                        value={obj.content}
                                                                        placeholder={`Content ${i + 1}`}
                                                                        onChange={e =>
                                                                            updateComplexItem(index, i, "content", e.target.value)
                                                                        }
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger mt-2"
                                                                        onClick={() => removeComplexItem(index, i)}
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </div>
                                                            ))}

                                                            <button
                                                                type="button"
                                                                className="btn btn-success"
                                                                disabled={block.items.length >= 3}
                                                                onClick={() => addComplexItem(index)}
                                                            >
                                                                + Add Card
                                                            </button>
                                                        </>
                                                    )}


                                                    {block.block_type === "card_grid_2" && (
                                                        <>
                                                            <input
                                                                className="form-control mb-2"
                                                                value={block.heading}
                                                                placeholder="Section heading"
                                                                onChange={e => updateSimple(index, "heading", e.target.value)}
                                                            />

                                                            <textarea
                                                                className="form-control mb-2"
                                                                value={block.intro}
                                                                placeholder="Intro text"
                                                                onChange={e => updateSimple(index, "intro", e.target.value)}
                                                            />

                                                            {block.items.map((item, i) => (
                                                                <div key={i} className="d-flex gap-2 mb-2">
                                                                    <input
                                                                        className="form-control"
                                                                        value={item}
                                                                        placeholder={`Content ${i + 1}`}
                                                                        onChange={e =>
                                                                            updateSimpleItem(index, i, e.target.value)
                                                                        }
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger"
                                                                        onClick={() => removeSimpleItem(index, i)}
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </div>
                                                            ))}

                                                            <button
                                                                type="button"
                                                                className="btn btn-success"
                                                                disabled={block.items.length >= 4}
                                                                onClick={() => addSimpleItem(index)}
                                                            >
                                                                + Add Item
                                                            </button>
                                                        </>
                                                    )}


                                                     {(block.block_type === "card_grid_3") && (
                                                        <>
                                                            <input
                                                                className="form-control mb-2"
                                                                value={block.heading}
                                                                placeholder="Heading section"
                                                                onChange={e => updateSimple(index, "heading", e.target.value)}
                                                            />

                                                            <textarea
                                                                className="form-control mb-2"
                                                                value={block.intro}
                                                                placeholder="Intro text"
                                                                onChange={e => updateSimple(index, "intro", e.target.value)}
                                                            />

                                                            {block.items.map((obj, i) => (
                                                                <div key={i} className="border p-2 mb-2">
                                                                    <input
                                                                        className="form-control mb-1"
                                                                        value={obj.heading}
                                                                        placeholder={`Heading ${i + 1}`}
                                                                        onChange={e =>
                                                                            updateComplexItem(index, i, "heading", e.target.value)
                                                                        }
                                                                    />
                                                                    <textarea
                                                                        className="form-control"
                                                                        value={obj.content}
                                                                        placeholder={`Content ${i + 1}`}
                                                                        onChange={e =>
                                                                            updateComplexItem(index, i, "content", e.target.value)
                                                                        }
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger mt-2"
                                                                        onClick={() => removeComplexItem(index, i)}
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </div>
                                                            ))}

                                                            <button
                                                                type="button"
                                                                className="btn btn-success"
                                                                disabled={block.items.length >= 4}
                                                                onClick={() => addComplexItem(index)}
                                                            >
                                                                + Add Card
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        {/* image uploD */}
                                        <div className="form-group">
                                            <label>Section image</label>

                                            <div className="input-group">
                                                <div className="custom-file">
                                                    <input
                                                        type="file"
                                                        className="custom-file-input"
                                                        accept="image/*"
                                                        onChange={handleFileChange}
                                                    />
                                                    <label className="custom-file-label">
                                                        {image ? image.name : "Choose file"}
                                                    </label>
                                                </div>
                                                <div className="input-group-append">
                                                    <span className="input-group-text">Upload</span>
                                                </div>
                                            </div>

                                            {/* Existing Image Preview */}

                                            <div className="mt-2">
                                                <img
                                                    src={
                                                        previewImage
                                                    }
                                                    alt="Preview"
                                                    className="img-fluid img-bordered"
                                                    style={{ width: "100px" }}
                                                />
                                            </div>

                                        </div>

                                    </div>

                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}
export default SeniorSecondarySection;